module.exports = __webpack_public_path__ + "img/join_3.767fc12b.jpg";